import React from 'react'
import { motion } from 'framer-motion'
import PuppyGrid from '../components/PuppyGrid'
import SEOMetaTags from '../components/SEOMetaTags'

const AvailablePuppiesPage = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Cane Corso Puppies",
    "description": "Premium AKC registered Cane Corso puppies from champion bloodlines. Health guaranteed, vet-checked, and family socialized. Available for loving homes.",
    "brand": {
      "@type": "Brand",
      "name": "NorCal Cane Corso Puppies"
    },
    "category": "Pets > Dogs > Puppies",
    "offers": {
      "@type": "AggregateOffer",
      "priceCurrency": "USD",
      "lowPrice": "800",
      "highPrice": "800",
      "offerCount": "10",
      "availability": "https://schema.org/InStock",
      "validFrom": "2025-01-01",
      "seller": {
        "@type": "Organization",
        "name": "NorCal Cane Corso Puppies",
        "url": "https://norcalcanecorsopuppies.com"
      }
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "200",
      "bestRating": "5",
      "worstRating": "1"
    },
    "review": [
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": "Sarah M."
        },
        "reviewBody": "We reserved our Cane Corso and the process was smooth from start to finish. Weekly photo updates and clear communication. Highly recommend!"
      }
    ],
    "additionalProperty": [
      {
        "@type": "PropertyValue",
        "name": "Health Guarantee",
        "value": "Comprehensive"
      },
      {
        "@type": "PropertyValue",
        "name": "Registration",
        "value": "AKC Registered"
      },
      {
        "@type": "PropertyValue",
        "name": "Age",
        "value": "10 weeks"
      }
    ]
  }

  return (
    <>
      <SEOMetaTags
        title="Available Cane Corso Puppies for Sale"
        description="Browse our beautiful available Cane Corso puppies for sale. AKC registered, health guaranteed, from champion bloodlines. 10 stunning puppies ready for loving homes in Northern California."
        keywords="Cane Corso puppies for sale, available puppies, AKC registered, champion bloodlines, Northern California, Italian Mastiff puppies, health guaranteed dogs"
        canonical="/available-puppies"
        ogTitle="Available Cane Corso Puppies - Premium Italian Mastiff Dogs"
        ogDescription="10 beautiful Cane Corso puppies available now! Champion bloodlines, health guarantees, AKC registered. View photos, personalities, and reserve your perfect companion."
        structuredData={structuredData}
      />
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="page-wrapper"
      >
        <PuppyGrid />
      </motion.div>
    </>
  )
}

export default AvailablePuppiesPage